<script lang="ts" setup>
import { computed } from 'vue';
import { FormBuilder } from '../../Utils';
import { useLocalization } from '@/plugins/localization';
import { Definition, LogitoChoiceType, LogitoChoiceEntry, instanceOfLogitoChoiceEntry, LogitoChoiceFieldTypes } from '.';

export interface Props
{
    builder: FormBuilder;
    component: LogitoChoiceType;
    index: number;
}

defineOptions({
    name: `${Definition.type}-filter`
});

const { $t } = useLocalization();

const props = defineProps({
  "builder": null,
  "component": null,
  "index": null
});
const component = computed(() => props.component);
const entry = computed(() => props.builder.initEntry(props.component, new LogitoChoiceEntry(), instanceOfLogitoChoiceEntry) as LogitoChoiceEntry);
const display = computed(() =>
{
    if (entry.value.data && entry.value.data.length == 1)
        return component.value.options.where(p => p.value == entry.value.data[0]).select(p => p.text).first();

    if (entry.value.data && entry.value.data.length > 1)
        return $t('[[[Wybrane %0 na %1|||{0}|||{1}]]]', entry.value.data.length, component.value.options.length);

    return null;
});
const model = computed({
    get()
    {
        return multiple.value ? (entry.value.data ?? []) : entry.value.data;
    },
    set(value)
    {
        entry.value.data = Array.isArray(value) ? value : [value];
    }
});
const multiple = computed(() => component.value.fieldType == LogitoChoiceFieldTypes.Checkbox);

const reset = (): void =>
{
    entry.value.data = null;
};
</script>

<template>
    <ideo-filter :name="component.name" :label="component.label" :visible="component.showFilter" :index="index" :display="display" @clear="reset">
        <ideo-form-select name="status" v-model="model" :options="component.options" :size="Math.min(10, component.options.length)" :multiple="multiple"></ideo-form-select>
    </ideo-filter>
</template>
